<template>
  <VBtn class="header" flat @click="logout">{{ title }}</VBtn>
</template>

<script lang="ts" setup>
  // Types
  import type { IAuthModel } from '~/misc/auth/types';

  // Composables
  import { useExitConfirmation } from '~/composables/use-exit-confirmation';

  // Components
  import VBtn from '~/misc/v-btn';

  const props = defineProps({
    authModel: {
      type: Object as PropType<IAuthModel>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  });

  const emit = defineEmits<{
    (e: 'on-logout'): void;
  }>();

  const { confirmExit } = useExitConfirmation();

  const logout = async () => {
    if (!(await confirmExit())) return;

    props.authModel.logout().finally(() => emit('on-logout'));
  };
</script>
